<template>
  <BaseCard>
    <div
      v-for="item in items"
      :key="item.section"
      :class="[
        $style.navItem,
        {
          [$style.isActive]: section === item.section,
          [$style.isDisabled]: item.disabled
        }
      ]"
      @click="!item.disabled && (section = item.section)"
      v-test="`tw-nav-${item.section}`"
    >
      <BaseText :iconBefore="item.icon">
        {{ $t(`admin.treatwell.pages.${item.section}.heading`) }}
      </BaseText>
    </div>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { computed } from 'vue';
import type { IconName } from '@/components/base-icon/types';
import type { DashboardSection } from './types';

const section = defineModel<DashboardSection>('section', { required: true });

const props = defineProps<{
  // The profile and reviews open once the salon finished the required setup
  setupDone: boolean;
}>();

const items = computed<
  { section: DashboardSection; icon: IconName; disabled: boolean }[]
>(() => [
  { section: 'dashboard', icon: 'home', disabled: false },
  { section: 'profile', icon: 'image', disabled: !props.setupDone },
  { section: 'reviews', icon: 'star', disabled: !props.setupDone },
]);
</script>

<style
  lang="scss"
  module
>
.navItem {
  display: block;
  width: 100%;
  padding: $spacing;
  border-radius: $radius;
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: $spacing * 0.25;
  }

  &.isActive {
    background-color: var(--color-highlight);
  }

  @include hover {
    background-color: var(--color-highlight);
  }

  &.isDisabled {
    cursor: not-allowed;
    opacity: 0.5;

    @include hover {
      background-color: transparent;
    }
  }
}
</style>
